<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { handleNext } from '../tutorialSteps'
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const playerFlagsStore = usePlayerFlagsStore()

const handleNextStep = async () => {
  await handleNext('tutorial_spy_end')
  await playerFlagsStore.setFlag('tutorial_complete', 'true')
}
</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/spy.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.spy.end.beneficial') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.spy.end.canBeKilled') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.spy.end.balanceRisk') }}
      </p>
    </template>

    <template #alerts>
    </template>

    <template #buttons>
      <ActionButton @click="handleNextStep">
        {{ t('tutorial.spy.end.gotIt') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>